import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default function setCarousel() {
  const productsCarousel = document.querySelectorAll('[data-products-carousel]');

  productsCarousel.forEach((section) => {
    const carousel = section.querySelector('.swiper');
    const pagination = section.querySelector('.swiper-pagination');
    const next = section.querySelector('.swiper-button-next');
    const prev = section.querySelector('.swiper-button-prev');

    if (!carousel) return;

    new Swiper(carousel, {
      modules: [Navigation, Pagination],
      slidesPerView: 1.7,
      spaceBetween: 0,
      watchOverflow: true,
      speed: 600,
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
      pagination: {
        el: pagination,
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 3.2,
        },
        992: {
          slidesPerView: 4.25,
        },
      },
    });
  });
}
